exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-cust[data-v-11494273]{max-height:245px}", ""]);

// exports
